/* istanbul ignore file */
export function broadcastBlockLoad(blockClassName) {
    const _BUS = window && window["sbMsgBus"];
    const pref = _BUS && _BUS.sbPrefix || "sb_";
    if (_BUS && typeof _BUS.post === "function") {
        _BUS.post({ [`${pref}${blockClassName}_loaded`]: true });
    }
}
//# sourceMappingURL=broadcastBlockLoad.js.map